'use es6';

export const ColorPickerModes = {
  ADVANCED: 'advanced',
  BRAND: 'brand',
  SIMPLE: 'simple',
};

export const DefaultColorGrid = [
  // row 1
  '#000000',
  '#FF0201',
  '#FF9902',
  '#FFFF04',
  '#00FF03',
  '#00FFFF',
  '#0600FF',
  '#9A00FF',
  '#FF00FF',
  // row 2
  '#FFFFFF',
  '#F4CCCC',
  '#FCE5CD',
  '#FFF2CC',
  '#D9EAD3',
  '#D0E0E3',
  '#CFE2F3',
  '#D9D2E9',
  '#EAD1DC',
  // row 3
  '#FAFAFA',
  '#EA9999',
  '#F9CB9C',
  '#FFE599',
  '#B6D7A8',
  '#A2C4C9',
  '#9FC5E8',
  '#B4A7D6',
  '#D5A6BD',
  // row 4
  '#EEEEEE',
  '#E06666',
  '#F6B26B',
  '#FFD966',
  '#93C47D',
  '#76A5AF',
  '#6FA8DC',
  '#8E7CC3',
  '#C27BA0',
  // row 5
  '#CCCCCC',
  '#CC0201',
  '#E69138',
  '#F1C233',
  '#69A84F',
  '#45818E',
  '#3D85C6',
  '#674EA7',
  '#A64D79',
  // row 6
  '#999999',
  '#990100',
  '#B45F06',
  '#BF9002',
  '#37761D',
  '#134F5C',
  '#0C5394',
  '#351C75',
  '#741B47',
  // row 7
  '#666666',
  '#660000',
  '#783F04',
  '#7F6001',
  '#274E13',
  '#0C343D',
  '#073763',
  '#20124D',
  '#4C1130',
];
